export function getSelectedMembers(optionElems) {
    let membersList = [...optionElems].filter((member) => member.selected);
    if (membersList.length === 0) {
        membersList = [...optionElems];
    }
    return membersList;
}
